var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32546 8.82648L10.9993 1.15261C11.6359 0.51604 12.668 0.516041 13.3045 1.15261L20.9784 8.82648C21.615 9.46304 21.615 10.4951 20.9784 11.1317L13.3045 18.8056C12.668 19.4421 11.6359 19.4421 10.9993 18.8056L3.32546 11.1317C2.68889 10.4951 2.68889 9.46304 3.32546 8.82648Z",
    fill: "#03a08d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2519 13.4854C21.6281 13.1092 22.259 13.1888 22.4873 13.6694C23.1921 15.1533 23.5879 16.8125 23.5879 18.5645C23.5876 24.88 18.4678 30 12.1523 30C5.83691 30 0.717045 24.88 0.716797 18.5645C0.716797 16.8127 1.11203 15.1533 1.81653 13.6694C2.04471 13.1888 2.67561 13.1092 3.05184 13.4854L11.576 22.0087C11.8943 22.327 12.4103 22.327 12.7286 22.0087L21.2519 13.4854Z",
    fill: "#03a08d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.c1d15c994538b86f93d7f2347f132f1c.svg";
export { ForwardRef as ReactComponent };